defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/LoadingRing',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril'
  ],
  function (m) {
    // Context:
    const LoadingRing = () => {

      // Return:
      return m('.loading-ring', [1, 2, 3, 4].map(function () {
        return m('.loading-ring__segment');
      }));
    };

    // Public functions:
    return LoadingRing;
  });
